import { template as template_bd9fa5c196184213b6fb0a01182aff2b } from "@ember/template-compiler";
import { uniqueId } from '@ember/helper';
import Component from '@glimmer/component';
import { on } from '@ember/modifier';
export default class FileInput extends Component {
    onChange = ({ target })=>{
        this.args.onChange(target.files, ()=>{
            if (target) {
                target.value = '';
            }
        }, this.args.reference || null, this.args.callback || null);
    };
    static{
        template_bd9fa5c196184213b6fb0a01182aff2b(`
    <span
      class="
        component-file-input
        x-file-input
        {{@class}}
        {{if @disabled "x-file-input--disabled"}}
      "
    >
      {{#let (uniqueId) as |uid|}}
        <input
          type="file"
          id={{uid}}
          class="x-file--input"
          disabled={{@disabled}}
          {{on "change" this.onChange}}
          ...attributes
        >
        <label for={{uid}}>
          {{yield}}
        </label>
      {{/let}}
    </span>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
